import { render } from "./ASnackbar.vue?vue&type=template&id=64ce87b5&scoped=true"
import script from "./ASnackbar.vue?vue&type=script&lang=js"
export * from "./ASnackbar.vue?vue&type=script&lang=js"

import "./ASnackbar.vue?vue&type=style&index=0&id=64ce87b5&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ce87b5"]])

export default __exports__